export const getCharacterCount = (item: string): string => {
  if (!item || item.length === 0) {
    return '';
  }
  return String(item.length);
};
